import { useOrganizationSource } from '../../../hooks/useOrganizationSource'
import { useOrganizationBookkeepers } from '../../settings/routes/OrganizationSettingsUsers/hooks/useOrganizationBookkeepers'

export const useFindAccountantAvailability = () => {
  const { isSourceBilly } = useOrganizationSource()
  const { data, isLoading: areBookkeeepersLoading } = useOrganizationBookkeepers({
    refetchOnWindowFocus: false,
  })

  const hasBookkeepers = data.length !== 0

  return {
    isFindAccountAvailable: isSourceBilly && !areBookkeeepersLoading && !hasBookkeepers,
  }
}
